/**
 * @file Openapi Schema
 * @version 0.1.0
 * @author Openapi Generator src_common/server/node_task/run_app/openapi/openapi.ts
 * @date 2025-10-21T07:27:46.279Z
 *
 * Details:
 * --- File generated by generator do not modify this file manually ---
 */

import { z } from 'zod';


// #/components/schemas/identityVerificationVariant
export const IdentityVerificationVariantZod = z.union([z.literal('IdCard'), z.literal('IdCardProofOfAddress'), z.literal('IdCardAndFace'), z.literal('IdCardAndFaceProofOfAddress')]);
export type IdentityVerificationVariantType = z.TypeOf<typeof IdentityVerificationVariantZod>;


// #/components/schemas/identityTriggerRequest
export const IdentityTriggerRequestZod = z.object({
    accountId: z.number(),
    universe: z.string(),
    verificationVariant: IdentityVerificationVariantZod,
    triggerReason: z.string(),
});
export type IdentityTriggerRequestType = z.TypeOf<typeof IdentityTriggerRequestZod>;


// #/components/schemas/identityEmptyResponse
export const IdentityEmptyResponseZod = z.unknown();
export type IdentityEmptyResponseType = z.TypeOf<typeof IdentityEmptyResponseZod>;


// #/components/schemas/identityEkycVerificationProgress
export const IdentityEkycVerificationProgressZod = z.union([z.literal('passed'), z.literal('requested'), z.literal('failed'), z.literal('not-checked'), z.literal('cancelled')]);
export type IdentityEkycVerificationProgressType = z.TypeOf<typeof IdentityEkycVerificationProgressZod>;


// #/components/schemas/identityEkycVerificationResult
export const IdentityEkycVerificationResultZod = z.union([z.literal('success'), z.literal('failure'), z.literal('not-checked'), z.literal('cancelled')]);
export type IdentityEkycVerificationResultType = z.TypeOf<typeof IdentityEkycVerificationResultZod>;


// #/components/schemas/identityVerificationProgressResponse
export const IdentityVerificationProgressResponseZod = z.object({
    id: z.number(),
    universe: z.string(),
    accountId: z.number(),
    progress: IdentityEkycVerificationProgressZod,
    rawResult: z.unknown(),
    createdAt: z.string(),
    finalizedAt: z.string().optional(),
    verificationVariant: IdentityVerificationVariantZod,
    triggerOrigin: z.string(),
    verificationResult: IdentityEkycVerificationResultZod,
    verificationIdStatus: IdentityEkycVerificationProgressZod,
    verificationPoaStatus: IdentityEkycVerificationProgressZod,
    verificationFaceStatus: IdentityEkycVerificationProgressZod,
});
export type IdentityVerificationProgressResponseType = z.TypeOf<typeof IdentityVerificationProgressResponseZod>;


// #/components/schemas/identityVerificationStatus
export const IdentityVerificationStatusZod = z.object({
    id: z.number(),
    universe: z.string(),
    accountId: z.number(),
    progress: IdentityEkycVerificationProgressZod,
    rawResult: z.unknown(),
    createdAt: z.string(),
    finalizedAt: z.string().optional(),
    verificationVariant: IdentityVerificationVariantZod,
    triggerOrigin: z.string(),
    verificationResult: IdentityEkycVerificationResultZod,
    verificationIdStatus: IdentityEkycVerificationProgressZod,
    verificationPoaStatus: IdentityEkycVerificationProgressZod,
    verificationFaceStatus: IdentityEkycVerificationProgressZod,
});
export type IdentityVerificationStatusType = z.TypeOf<typeof IdentityVerificationStatusZod>;


// #/components/schemas/identityVerificationStatusRaw
export const IdentityVerificationStatusRawZod = z.object({
    statusCode: z.string(),
    statusMessage: z.string(),
    requestId: z.number(),
    traceId: z.string(),
    ipAddress: z.string(),
});
export type IdentityVerificationStatusRawType = z.TypeOf<typeof IdentityVerificationStatusRawZod>;


// #/components/schemas/identityVerificationStatusResponse
export const IdentityVerificationStatusResponseZod = z.object({
    verification: IdentityVerificationStatusZod,
    status: IdentityVerificationStatusRawZod.optional(),
});
export type IdentityVerificationStatusResponseType = z.TypeOf<typeof IdentityVerificationStatusResponseZod>;


// #/components/schemas/identityCancelRequest
export const IdentityCancelRequestZod = z.object({
    accountId: z.number(),
});
export type IdentityCancelRequestType = z.TypeOf<typeof IdentityCancelRequestZod>;

